<ix-fieldset [title]="'OAuth Authentication' | translate" [formGroup]="form">
  <ix-oauth-button
    testId="log-in-to-provider"
    [oauthType]="oauthType.Provider"
    [oauthUrl]="oauthUrl + '?origin='"
    [isLoggedIn]="hasOauthAuthorization"
    (loggedIn)="onLoggedIn($event)"
  ></ix-oauth-button>

  <ix-input
    formControlName="client_id"
    [label]="'OAuth Client ID' | translate"
  ></ix-input>

  <ix-input
    formControlName="client_secret"
    type="password"
    [label]="'OAuth Client Secret' | translate"
  ></ix-input>
</ix-fieldset>
